<template>
    <div class="wtw-container small wtw-form account-create-container clearfix">

        <div class="input-container">
            <input v-model="user.profile_first_name"
                   tabindex="1"
                   type="text"
                   name="First Name"
                   placeholder="First Name"
                   :class="{'error': errors.has('First Name') }"
                   @click="focus"
                   @input="hideErrors"
            />
            <span v-show="errors.has('First Name')" class="error-message">{{ errors.first('First Name') }}</span>
        </div>
        <div class="input-container">
            <input v-model="user.profile_last_name"
                   tabindex="2"
                   type="text"
                   name="Last Name"
                   placeholder="Last Name"
                   :class="{'error': errors.has('Last Name') }"
                   @click="focus"
                   @input="hideErrors"
            />
            <span v-show="errors.has('last_name')" class="error-message">{{ errors.first('Last Name') }}</span>
        </div>
        <div class="input-container">
            <input v-model="user.user_email"
                   tabindex="3"
                   @input="hideErrors"
                   v-validate="'required|email'"
                   type="email"
                   name="Email"
                   placeholder="Email"
                   @click="focus"
                   :class="{'error': errors.has('Email') }"
            />
            <span v-show="errors.has('Email')" class="error-message">{{ errors.first('Email') }}</span>
        </div>

        <div class="input-container">
            <input v-model="user.user_password" v-validate="'required'" type="password" name="password" tabindex="4"
                   placeholder="Password" @click="focus" @input="hideErrors"/>
            <span v-if="errorMessage && !passwordMatchError && showErrors" class="error-message">{{ errorMessage.message || errorMessage }}</span>
            <a v-if="errorMessage && showErrors && errorMessage.showLoginLink" class="error-message" @click.stop="$router.push('/account/login')">Please, <span class="login-link ">sign-in</span> instead</a>
        </div>
    </div>
</template>

<script>
    export default{
        data(){
            return {
                user: {
                    profile_name: null,
                    profile_last: null,
                    user_email: null,
                    user_password: null,
                },
                showErrors: true,
                passwordConfirm: null,
                passwordMatchError: null
            }
        },
        props: ['options', 'sendOptions', 'optionsAll', 'errorMessage'],
        methods: {
            hideErrors(){
                this.showErrors = false;
            },
            focus(event){
              // Not quite sure why this is necessary but it was requiring multiple taps to gain focus
              event.target.focus()
            }
        },
        watch: {
            sendOptions: function () {
                if (this.sendOptions) {
                    this.$parent.$emit('registerUser', this.user);
                    this.showErrors = true;
                }
            }
        },
        mounted () {
          console.log('preload gif');
          let image = new Image(); 
          image.src = 'images/account-complete-animation.gif'
        }
    }
</script>